import firebase from "firebase/app";
import Vue from "vue";
import Router from "vue-router";

import Layout from "./components/Layout.vue";
import Home from "./views/Home.vue";
import Download from "./views/Download.vue";
import Login from "./views/Login.vue";
import Feedback from "./views/Feedback.vue";
import MoodFeedback from "./views/MoodFeedback.vue";
import User from "./views/User.vue";
import AdminUsers from "./views/AdminUsers.vue";
import Groups from "./views/Groups.vue";
import SealedEnvelopes from "./views/SealedEnvelopes.vue";
import Settings from "./views/Settings.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      redirect: "/login"
    },
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/download",
      name: "Download",
      component: Download
    },
    {
      path: "/",
      component: Layout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: "home",
          name: "Home",
          component: Home
        },
        {
          path: "feedback",
          name: "Feedback",
          component: Feedback
        },
        {
          path: "mood-feedback",
          name: "Mood Feedback",
          component: MoodFeedback
        },
        {
          path: "admin-users",
          name: "Admin Users",
          component: AdminUsers
        },
        {
          path: "user/:id",
          name: "User",
          component: User
        },
        {
          path: "groups",
          name: "Groups",
          component: Groups
        },
        {
          path: "envelopes",
          name: "Sealed Envelopes",
          component: SealedEnvelopes
        },
        {
          path: "settings",
          name: "Settings",
          component: Settings
        }
      ]
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const idTokenPromise = currentUser
    ? await currentUser.getIdTokenResult()
    : null;
  const idTokenResult =
    idTokenPromise && idTokenPromise.claims ? idTokenPromise.claims.role : null;
  const restrictedPages = ["Groups", "Admin Users", "Settings"];

  if (requiresAuth && !currentUser) next("login");
  else if (to.name === "Login" && currentUser) next("home");
  else if (
    restrictedPages.includes(to.name) &&
    (!idTokenResult ||
      !(idTokenResult === "admin" || idTokenResult === "manager"))
  )
    next("home");
  else next();
});

export default router;
